/**
 * @license
 * Copyright SciFlow GmbH All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at http://sciflow.org/license
 */

import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { EditorOverlay } from './editor-overlay';
import { EditorOverlayContainer } from './editor-overlay-container';
import { ErrorDialogComponent } from './error-dialog/error-dialog.component';
import { ErrorDialogService } from './error-dialog/error-dialog.service';
import { PMEditorComponent } from './pm-editor.component';
import { SelectionActionsComponent } from './selection-actions/selection-actions.component';
import { StructureMenuComponent } from './structure-menu/structure-menu.component';
import { QuickActionsComponent } from './quick-actions/quick-actions.component';
import { QuickActionsMenuComponent } from './quick-actions/quick-actions-menu/quick-actions-menu.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MetadataMenuComponent } from './metadata-menu/metadata-menu.component';
import { ProsemirrorSchemaPrefetchService } from './services/prosemirror-schema-prefetch.service';

@NgModule({
  declarations: [
    PMEditorComponent,
    SelectionActionsComponent,
    StructureMenuComponent,
    ErrorDialogComponent,
    QuickActionsComponent,
    QuickActionsMenuComponent,
    MetadataMenuComponent,
  ],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatBottomSheetModule,
    MatSelectModule,
    MatSnackBarModule,
    MatIconModule,
    MatTooltipModule,
    MatDialogModule,
    PortalModule,
    OverlayModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatDividerModule,
    MatBadgeModule,
    HttpClientModule,
  ],
  providers: [
    EditorOverlayContainer,
    EditorOverlay,
    {
      provide: MatDialogRef,
      useValue: {},
    },
    ErrorDialogService,
  ],
  exports: [PMEditorComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProsemirrorModule {
  constructor(prefetchService: ProsemirrorSchemaPrefetchService) {
    if (typeof window !== 'undefined') {
      (window as any).__prosemirrorModuleConstructed = (window as any).__prosemirrorModuleConstructed ?? 0;
      (window as any).__prosemirrorModuleConstructed += 1;
    }
    if (typeof console !== 'undefined' && console?.log) {
      console.log('[ProsemirrorModule] Initialising, ensuring schemas are prefetched');
    }
    prefetchService.ensureLoaded();
  }
}
